<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <!-- Client Balance -->
      <v-col cols="12" sm="12" md="6" lg="7" v-if="$ha(270)">
        <v-card v-if="clientBalancesMap && clientBalancesMap[balanceForEntity]">
          <v-card-text style="color: #509bb0; padding: 5px 15px 0px">
            <v-row>
              <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4"
                ><span style="font-size: 11px">{{
                  $i18n.t("Client Balance")
                }}</span>
                <h6>
                  <v-icon
                    v-if="totalClientBalCur == 'INR'"
                    style="font-size: 16px; color: rgb(80, 155, 176)"
                    >mdi-currency-inr</v-icon
                  >{{ getTotalClientBal(clientBalancesMap[balanceForEntity]) }}
                </h6>
              </v-col>
              <v-col style="height: 28px" cols="12" sm="4" md="4" lg="5"
                ><v-select
                  v-model="balanceForEntity"
                  :items="balanceBranchList"
                  dense
                  item-text="name"
                  item-value="value"
                ></v-select
              ></v-col>
              <v-col
                style="height: 28px; padding-left: 0px"
                cols="12"
                sm="4"
                md="4"
                lg="3"
                ><z-month-picker
                  style="color: red"
                  :label="''"
                  dense
                  :clear="true"
                  v-model="clientbalanceYearMonth"
              /></v-col>
            </v-row>
          </v-card-text>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text">{{ $i18n.t("POD Pending") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("POD Amt") }}
                </th>
                <th class="primary--text">{{ $i18n.t("Un Invoiced") }}</th>
                <th class="primary--text">{{ $i18n.t("Active") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Amount") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="clientBalancesMap && clientBalancesMap[balanceForEntity]">
              <tr
                v-for="(bal, index) in clientBalancesMap[balanceForEntity]"
                :key="index"
              >
                <td>{{ bal.corpName }}</td>
                <td>{{ bal.podPending || 0 }}</td>
                <td>
                  <span
                    class="float-right"
                    v-if="bal.podPendingAmount != null"
                    >{{ bal.podPendingAmount.toFixed(0) }}</span
                  >
                </td>
                <td>
                  {{
                    bal.unInvoicedAmount ? bal.unInvoicedAmount.toFixed(0) : 0
                  }}
                </td>
                <td>{{ bal.activeTrips || 0 }}</td>
                <td>
                  <span class="float-right" v-if="bal.amount != null">{{
                    bal.amount.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="clientBalancesMap && clientBalancesMap[balanceForEntity]">
              <tr style="background-color: rgb(220 241 254)">
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text">
                  {{ getPodPending(clientBalancesMap[balanceForEntity]) }}
                </th>
                <th class="primary--text text-right">
                  {{ getPodAmount(clientBalancesMap[balanceForEntity]) }}
                </th>
                <th class="primary--text">
                  {{ getUnInvoiced(clientBalancesMap[balanceForEntity]) }}
                </th>
                <th class="primary--text">{{ getActive(clientBalancesMap[balanceForEntity]) }}</th>
                <th class="primary--text text-right">
                  {{ getAmount(clientBalancesMap[balanceForEntity]) }}
                </th>
              </tr>
            </tfoot>

            <!-- <tbody v-if="clientBalances">
              <tr v-for="(bal, index) in clientBalances" :key="index">
                <td>{{ bal.corpName }}</td>
                <td>{{ bal.podPending || 0 }}</td>
                <td>
                  <span
                    class="float-right"
                    v-if="bal.podPendingAmount != null"
                    >{{ bal.podPendingAmount.toFixed(0) }}</span
                  >
                </td>
                <td>
                  {{
                    bal.unInvoicedAmount ? bal.unInvoicedAmount.toFixed(0) : 0
                  }}
                </td>
                <td>{{ bal.activeTrips || 0 }}</td>
                <td>
                  <span class="float-right" v-if="bal.amount != null">{{
                    bal.amount.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="background-color: rgb(220 241 254)">
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text">
                  {{ clientBalances.getPodPending1 }}
                </th>
                <th class="primary--text text-right">
                  {{ clientBalances.getPodAmount1 }}
                </th>
                <th class="primary--text">
                  {{ clientBalances.getUnInvoiced1 }}
                </th>
                <th class="primary--text">{{ clientBalances.getActive1 }}</th>
                <th class="primary--text text-right">
                  {{ clientBalances.getAmount1 }}
                </th>
              </tr>
            </tfoot> -->
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- Supplier Balance -->
      <v-col cols="12" sm="12" md="6" lg="5" v-if="$ha(270)">
        <v-card>
          <v-card-text style="color: #509bb0; padding: 5px 15px 0px">
            <v-row>
              <v-col cols="12" sm="8" md="8" lg="8">
                <h4 style="color: rgb(205 76 205)">
                  {{ $i18n.t("Supplier Balance") }}
                </h4>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="4" lg="4" style="text-align: right">
                <span>
                  <h6>
                    <!-- <v-icon
                      v-if="totalSupBalCur == 'INR'"
                      style="font-size: 16px; color: rgb(80, 155, 176)"
                      >mdi-currency-inr</v-icon
                    > -->
                    <span v-if="supplierBalancesMap">{{
                      getTotalSupBal(supplierBalancesMap["all"])
                    }}</span>
                  </h6>
                </span>
              </v-col>
            </v-row>
            <!-- <h5 v-if="index != 'all'" style="color:#d14bd1">
              {{ index }} -
              <span style="font-size: 12px">{{
                $i18n.t("Supplier Balance")
              }}</span>
            </h5> -->
          </v-card-text>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text">{{ $i18n.t("Active Trips") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Amount") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="supplierBalancesMap && supplierBalancesMap['all']">
              <tr
                v-for="(bal, index) in supplierBalancesMap['all']"
                :key="index"
              >
                <td>{{ bal.corpName }}</td>
                <td>{{ bal.activeTrips || 0 }}</td>
                <td>
                  <span class="float-right" v-if="bal.amount != null">{{
                    bal.amount.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="supplierBalancesMap">
              <tr style="background-color: #f8dcfe">
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text">
                  {{ getActive(supplierBalancesMap["all"]) }}
                </th>
                <th class="primary--text text-right">
                  {{ getAmount(supplierBalancesMap["all"]) }}
                </th>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- Profit/Loss -->
      <v-col cols="12" sm="12" md="6" lg="6" v-if="$ha(270)">
        <v-card>
          <v-card-text style="color: #509bb0; padding: 5px 15px 0px">
            <v-row>
              <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4"
                ><h4 style="color: rgb(72 180 100)">
                  {{ $i18n.t("Profit/Loss") }}
                </h4>
                <span style="font-size: 11px">{{ $i18n.t("Monthly") }}</span>
              </v-col>
              <v-col style="height: 28px" cols="12" sm="4" md="4" lg="5"
                ><v-select
                  v-model="marginForEntity"
                  :items="marginBranchList"
                  dense
                  item-text="name"
                  item-value="value"
                ></v-select
              ></v-col>
              <v-col
                style="height: 28px; padding-left: 0px"
                cols="12"
                sm="4"
                md="4"
                lg="3"
                ><z-month-picker
                  style="color: red"
                  :label="''"
                  dense
                  v-model="marginYearMonth"
              /></v-col>
            </v-row>
          </v-card-text>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Amount") }}
                </th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Misc. Expense") }}
                </th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Margin") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="corpMarginMap && corpMarginMap[marginForEntity]">
              <tr
                v-for="(bal, index) in corpMarginMap[marginForEntity]"
                :key="index"
              >
                <td>{{ bal.corpName }}</td>
                <td class="text-right">{{ bal.clientAmount }}</td>
                <td class="text-right">{{ bal.expense }}</td>
                <td class="text-right">
                  <span class="float-right" v-if="bal.margin != null">{{
                    bal.margin.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="corpMarginMap">
              <tr style="background-color: rgb(220 254 230)">
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text text-right">
                  {{ getClientAmount(corpMarginMap[marginForEntity]) }}
                </th>
                <th class="primary--text text-right">
                  {{ getExpense(corpMarginMap[marginForEntity]) }}
                </th>
                <th class="primary--text text-right">
                  {{ getMargin(corpMarginMap[marginForEntity]) }}
                </th>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- Active Trips -->
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-card>
          <v-card-title style="color: #509bb0">
            <h5>{{ $i18n.t("Active Trips") }}</h5>
            <v-spacer></v-spacer>
            <h6>{{ activeTrips && activeTrips.length > 0 ? activeTrips[0].tripsCount : 0 }}</h6>
          </v-card-title>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text">{{ $i18n.t("Pickup") }}</th>
                <th class="primary--text">{{ $i18n.t("Drop") }}</th>
                <th class="primary--text">{{ $i18n.t("Start Time") }}</th>
              </tr>
            </thead>

            <tbody v-if="activeTrips">
              <tr v-for="(trp, index) in activeTrips" :key="index">
                <td>{{ trp.corpName }}</td>
                <td>{{ trp.src ? trp.src.city : "" }}</td>
                <td>{{ trp.dst ? trp.dst.city : "" }}</td>
                <td>{{ trp.startTime | moment("DD MMM YYYY") }}</td>
                <!-- <td>{{ trp.startTime | moment("HH:mm DD MMM YYYY") }}</td> -->
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- Client Invoice Balance -->
      <v-col cols="12" sm="12" md="6" lg="6" v-if="$ha(270)">
        <v-card>
          <v-card-title style="color: #509bb0">
            <h5>{{ $i18n.t("Client Invoice Balance") }}</h5>
            <v-spacer></v-spacer>
            <span>
              <h6>
                <v-icon
                  v-if="totalInvBalCur == 'INR'"
                  style="font-size: 16px; color: rgb(80, 155, 176)"
                  >mdi-currency-inr</v-icon
                >{{ getTotalClientInvoiceBal() }}
              </h6>
            </span>
          </v-card-title>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text">{{ $i18n.t("Count") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Amount") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="clientInvoiceBalances">
              <tr v-for="(bal, index) in clientInvoiceBalances" :key="index">
                <td>{{ bal.corpName }}</td>
                <td>{{ bal.activeTrips }}</td>
                <td>
                  <span class="float-right" v-if="bal.amount != null">{{
                    bal.amount.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text">
                  {{ getActive(clientInvoiceBalances) }}
                </th>
                <th class="primary--text text-right">
                  {{ getAmount(clientInvoiceBalances) }}
                </th>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- Client POD Pending -->
      <v-col cols="12" sm="12" md="6" lg="6" v-if="$ha(270)">
        <v-card>
          <v-card-title style="color: #509bb0">
            <h5>{{ $i18n.t("Client POD Pending Detail") }}</h5>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-simple-table fixed-header dense height="200px">
            <thead>
              <tr>
                <th class="primary--text">
                  {{ $i18n.t("Client") }}
                </th>
                <th class="primary--text">{{ $i18n.t("> 60 Days") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Pending Amt") }}
                </th>
                <th class="primary--text">{{ $i18n.t("> 30 Days") }}</th>
                <th class="primary--text text-right">
                  {{ $i18n.t("Pending Amt") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="clientPODBalances">
              <tr v-for="(bal, index) in clientPODBalances" :key="index">
                <td>{{ bal.corpName }}</td>
                <td>{{ bal.pod60Count }}</td>
                <td>
                  <span class="float-right" v-if="bal.pod60amount != null">
                    {{ bal.pod60amount.toFixed(0) }}</span
                  >
                </td>
                <td>{{ bal.pod30Count }}</td>
                <td>
                  <span class="float-right" v-if="bal.pod30amount != null">{{
                    bal.pod30amount.toFixed(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="primary--text">{{ $i18n.t("Total") }}</th>
                <th class="primary--text">
                  {{ getPOD60Count(clientInvoiceBalances) }}
                </th>
                <th class="text-right">
                  {{ getPOD60Amount(clientInvoiceBalances) }}
                </th>
                <th class="primary--text">
                  {{ getPOD30Count(clientInvoiceBalances) }}
                </th>
                <th class="text-right">
                  {{ getPOD30Amount(clientInvoiceBalances) }}
                </th>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
      </v-col>
      <!-- <v-col cols="12">
        <z-spark-select></z-spark-select>

      </v-col> -->

      <v-col cols="12" sm="12" md="12" lg="12" v-if="$ha(270)">
        <v-card>
          <v-card-title style="color: #509bb0">
            <h5>{{ $i18n.t("Vehicle Revenue Report") }}</h5>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-simple-table dense style="width: 100%">
            <thead>
              <tr>
                <th rowspan="2" class="bold">
                  {{ $i18n.t("SR.#") }}
                </th>
                <th rowspan="2" class="bold">
                  {{ $i18n.t("Reg. No") }}
                </th>
                <th rowspan="2" class="bold">
                  {{ $i18n.t("Vehicle Type") }}
                </th>
                <th colspan="6" style="text-align: center" class="bold">
                  {{ $i18n.t("Recurring Expenses") }}
                </th>
                <th colspan="3" style="text-align: center" class="bold">
                  {{ $i18n.t("Revenues") }}
                </th>
              </tr>
              <tr>
                <th>
                  <b>{{ $i18n.t("Insurance") }}</b>
                </th>
                <th>
                  <b>{{ $i18n.t("PUC") }}</b>
                </th>
                <th>
                  <b>{{ $i18n.t("Maintenance") }}</b>
                </th>
                <th>
                  <b>{{ $i18n.t("RTO") }}</b>
                </th>
                <th>
                  <b>{{ $i18n.t("Permits") }}</b>
                </th>
                <th>
                  <b>{{ $i18n.t("EMI") }}</b>
                </th>
                <th style="text-align: right">
                  <b>{{ formatIntegerMonth(vehRepMonth) }}</b>
                </th>
                <th style="text-align: right">
                  <b>{{ formatIntegerMonth(prevVehRepMonth) }}</b>
                </th>
                <th style="text-align: right">
                  <b>{{ formatIntegerMonth(prevPrevVehRepMonth) }}</b>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(report, index) in tripRevenueReports.rows" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <router-link :to="'/vehicle/' + report.vehicle._id" v-if="$ha(270)" class="my-5">
                    {{ report.vehicle.regNo }}
                </router-link>
                </td>
                <td>{{ report.vehicle.vehType }}</td>
                <td>
                  <span v-for="(k, v) in report.insurance" :key="v + index"
                    >{{ k }} <br
                  /></span>
                </td>
                <td>
                  <span v-for="(k, v) in report.puc" :key="v + index"
                    >{{ k }}  <br
                  /></span>
                </td>
                <td>
                  <span v-for="(k, v) in report.service" :key="v + index"
                    >{{ k }} <br
                  /></span>
                </td>
                <td>
                  <span v-for="(k, v) in report.rto" :key="v + index"
                    >{{ k }} <br
                  /></span>
                </td>
                <td>
                  <span v-for="(k, v) in report.permit" :key="v + index"
                    >{{ k }} <br
                  /></span>
                </td>
                <td>
                  <span v-for="(k, v) in report.emi" :key="v + index"
                    >{{ k}} <br
                  /></span>
                </td>
                <td style="text-align: right">
                  <span v-for="(k, v) in report.revenueCurrMonth" :key="v + index"
                    >{{ k }} 
                  </span>{{report.tripsCurrMonth ? "("+report.tripsCurrMonth+")" : ""}}
                </td>
                <td style="text-align: right">
                  <span v-for="(k, v) in report.revenuePrevMonth" :key="v + index"
                    >{{ k }}
                  </span>
                </td>
                <td style="text-align: right">
                  <span v-for="(k, v) in report.revenuePrevPrevMonth" :key="v + index"
                    >{{ k }}
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-container style="text-align: right;">
            <router-link :to="'/reports/vehicle/revenue'">
              <h4>
                {{ $i18n.t("Show More...")}}
              </h4>
            </router-link>
          </v-container>
        </v-card>
      </v-col>
      

      <!-- <v-col cols="12" lg="4">
        <trip-stats />
      </v-col>
      <v-col cols="12" lg="4">
        <vehicle-stats />
      </v-col>
      <v-col cols="12" lg="4">
        <driver-stats />
      </v-col> -->

      <!-- <v-col cols="12" lg="4">
        <base-material-chart-card
          :data="emailsSubscriptionChart.data"
          :options="emailsSubscriptionChart.options"
          :responsive-options="emailsSubscriptionChart.responsiveOptions"
          color="#E91E63"
          hover-reveal
          type="Bar"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" color="info" icon v-on="on">
                  <v-icon color="info">mdi-refresh</v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" light icon v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h4 class="card-title font-weight-light mt-2 ml-2">Website Views</h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">Last Campaign Performance</p>

          <template v-slot:actions>
            <v-icon class="mr-1" small>mdi-clock-outline</v-icon>
            <span class="caption grey--text font-weight-light">updated 10 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col cols="12" lg="4">
        <base-material-chart-card
          :data="dailySalesChart.data"
          :options="dailySalesChart.options"
          color="success"
          hover-reveal
          type="Line"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" color="info" icon v-on="on">
                  <v-icon color="info">mdi-refresh</v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" light icon v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h4 class="card-title font-weight-light mt-2 ml-2">Daily Sales</h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            <v-icon color="green" small>mdi-arrow-up</v-icon>
            <span class="green--text">55%</span>&nbsp; increase in today's sales
          </p>

          <template v-slot:actions>
            <v-icon class="mr-1" small>mdi-clock-outline</v-icon>
            <span class="caption grey--text font-weight-light">updated 4 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col cols="12" lg="4">
        <base-material-chart-card
          :data="dataCompletedTasksChart.data"
          :options="dataCompletedTasksChart.options"
          hover-reveal
          color="info"
          type="Line"
        >
          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" color="info" icon v-on="on">
                  <v-icon color="info">mdi-refresh</v-icon>
                </v-btn>
              </template>

              <span>Refresh</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" light icon v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <span>Change Date</span>
            </v-tooltip>
          </template>

          <h3 class="card-title font-weight-light mt-2 ml-2">Completed Tasks</h3>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">Last Last Campaign Performance</p>

          <template v-slot:actions>
            <v-icon class="mr-1" small>mdi-clock-outline</v-icon>
            <span class="caption grey--text font-weight-light">campaign sent 26 minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>-->

      <!-- <v-col cols="12" sm="6" lg="4" v-if="invoiceStats">
        <base-material-stats-card
          color="info"
          icon="mdi-text-box-search-outline"
          :title="$i18n.t('Pending Invoice Verification')"
          :value="invoiceStats.pendingVerification"
          sub-icon="mdi-clock"
          :sub-text="$i18n.t('Just Updated')"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="4" v-if="invoiceStats">
        <base-material-stats-card
          color="info"
          icon="mdi-text-box-search-outline"
          :title="$i18n.t('Pending Invoice Collection')"
          :value="invoiceStats.pendingCollection"
          sub-icon="mdi-clock"
          :sub-text="$i18n.t('Just Updated')"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="4" v-if="invoiceStats">
        <base-material-stats-card
          color="info"
          icon="mdi-text-box-search-outline"
          :title="$i18n.t('Pending Invoice Collection(Individual)')"
          :value="invoiceStats.pendingCollectionIndv"
          sub-icon="mdi-clock"
          :sub-text="$i18n.t('Just Updated')"
        />
      </v-col> -->

      <!-- <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          title="Website Visits"
          value="75.521"
          sub-icon="mdi-tag"
          sub-text="Tracked from Google Analytics"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="success"
          icon="mdi-store"
          title="Revenue"
          value="$ 34,245"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="orange"
          icon="mdi-sofa"
          title="Bookings"
          value="184"
          sub-icon="mdi-alert"
          sub-icon-color="red"
          sub-text="Get More Space..."
        />
      </v-col>-->

      <!-- <v-col cols="12" md="6">
        <base-material-card color="warning" class="px-5 py-3">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">Employees Stats</div>

            <div class="subtitle-1 font-weight-light">New employees on 15th September, 2016</div>
          </template>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" />
          </v-card-text>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="6">
        <base-material-card class="px-5 py-3">
          <template v-slot:heading>
            <v-tabs v-model="tabs" background-color="transparent" slider-color="white">
              <span class="subheading font-weight-light mx-3" style="align-self: center">Tasks:</span>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-bug</v-icon>Bugs
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-code-tags</v-icon>Website
              </v-tab>
              <v-tab>
                <v-icon class="mr-2">mdi-cloud</v-icon>Server
              </v-tab>
            </v-tabs>
          </template>

          <v-tabs-items v-model="tabs" class="transparent">
            <v-tab-item v-for="n in 3" :key="n">
              <v-card-text>
                <template v-for="(task, i) in tasks[tabs]">
                  <v-row :key="i" align="center">
                    <v-col cols="1">
                      <v-list-item-action>
                        <v-checkbox v-model="task.value" color="secondary" />
                      </v-list-item-action>
                    </v-col>

                    <v-col cols="9">
                      <div class="font-weight-light" v-text="task.text" />
                    </v-col>

                    <v-col cols="2" class="text-right">
                      <v-icon class="mx-1">mdi-pencil</v-icon>
                      <v-icon color="error" class="mx-1">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </base-material-card>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import TripStats from "@/views/dashboard/TripStats.vue";
import VehicleStats from "@/views/dashboard/VehicleStats.vue";
import DriverStats from "@/views/dashboard/DriverStats.vue";

@Component({
  components: {
    TripStats,
    VehicleStats,
    DriverStats,
  },
})
export default class Dashboard extends Vue {
  dailySalesChart = {
    data: {
      labels: ["M", "T", "W", "T", "F", "S", "S"],
      series: [[12, 17, 7, 17, 23, 18, 38]],
    },
    options: {
      lineSmooth: this.$chartist.Interpolation.cardinal({
        tension: 0,
      }),
      low: 0,
      high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
  };
  dataCompletedTasksChart = {
    data: {
      labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
      series: [[230, 750, 450, 300, 280, 240, 200, 190]],
    },
    options: {
      lineSmooth: this.$chartist.Interpolation.cardinal({
        tension: 0,
      }),
      low: 0,
      high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
  };

  emailsSubscriptionChart = {
    data: {
      labels: [
        "Ja",
        "Fe",
        "Ma",
        "Ap",
        "Mai",
        "Ju",
        "Jul",
        "Au",
        "Se",
        "Oc",
        "No",
        "De",
      ],
      series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]],
    },
    options: {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: 1000,
      chartPadding: {
        top: 0,
        right: 5,
        bottom: 0,
        left: 0,
      },
    },
    responsiveOptions: [
      [
        "screen and (max-width: 640px)",
        {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0];
            },
          },
        },
      ],
    ],
  };

  headers = [
    {
      sortable: false,
      text: "ID",
      value: "id",
    },
    {
      sortable: false,
      text: "Name",
      value: "name",
    },
    {
      sortable: false,
      text: "Salary",
      value: "salary",
      align: "right",
    },
    {
      sortable: false,
      text: "Country",
      value: "country",
      align: "right",
    },
    {
      sortable: false,
      text: "City",
      value: "city",
      align: "right",
    },
  ];
  items = [
    {
      id: 1,
      name: "Dakota Rice",
      country: "Niger",
      city: "Oud-Tunrhout",
      salary: "$35,738",
    },
    {
      id: 2,
      name: "Minerva Hooper",
      country: "Curaçao",
      city: "Sinaai-Waas",
      salary: "$23,738",
    },
    {
      id: 3,
      name: "Sage Rodriguez",
      country: "Netherlands",
      city: "Overland Park",
      salary: "$56,142",
    },
    {
      id: 4,
      name: "Philip Chanley",
      country: "Korea, South",
      city: "Gloucester",
      salary: "$38,735",
    },
    {
      id: 5,
      name: "Doris Greene",
      country: "Malawi",
      city: "Feldkirchen in Kārnten",
      salary: "$63,542",
    },
  ];
  tabs = 0;
  tasks = {
    0: [
      {
        text: 'Sign contract for "What are conference organizers afraid of?"',
        value: true,
      },
      {
        text: "Lines From Great Russian Literature? Or E-mails From My Boss?",
        value: false,
      },
      {
        text:
          "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
        value: false,
      },
      {
        text: "Create 4 Invisible User Experiences you Never Knew About",
        value: true,
      },
    ],
    1: [
      {
        text:
          "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
        value: true,
      },
      {
        text: 'Sign contract for "What are conference organizers afraid of?"',
        value: false,
      },
    ],
    2: [
      {
        text: "Lines From Great Russian Literature? Or E-mails From My Boss?",
        value: false,
      },
      {
        text:
          "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
        value: true,
      },
      {
        text: 'Sign contract for "What are conference organizers afraid of?"',
        value: true,
      },
    ],
  };
  list = {
    0: false,
    1: false,
    2: false,
  };

  tripStats = null;
  cargoStats = null;
  vehicleStats = null;
  driverStats = null;
  invoiceStats = null;
  corpMarginMap = null;
  clientBalancesMap = null;
  clientInvoiceBalances = null;
  clientPODBalances = null;
  supplierBalancesMap = null;
  activeTrips = null;
  marginYearMonth = null;
  clientbalanceYearMonth = null;
  marginDate = null;
  marginForEntity = "all";
  balanceForEntity = "all";
  marginBranchList = [];
  balanceBranchList = [];
  tripRevenueReports = [];
  vehRepMonth = null;
  prevVehRepMonth = null;
  prevPrevVehRepMonth = null;

  complete(index) {
    this.list[index] = !this.list[index];
  }

  async vehicleRevReports() {
    if (!this.vehRepMonth) {
      return;
    }
    const u = "/api/vehicle/grid?forReport=true&forMonth=:month";
    try {
      const response = await doGet(u.replace(':month', this.vehRepMonth) + "&rows=5&page=1&sord=asc&sidx=_id");
      this.tripRevenueReports = response;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async getDashboardStats() {
    common.setLoading(true);
    try {
      const response = await doGet("/api/dashboard/statistics");
      common.setLoading(false);
      if (response) {
        if (response.TRIP_STATS) {
          this.tripStats = response.TRIP_STATS;
        }
        if (response.CARGO_STATS) {
          this.cargoStats = response.CARGO_STATS;
        }
        if (response.VEHICLE_STATS && response.VEHICLE_STATS.stats) {
          this.vehicleStats = response.VEHICLE_STATS.stats;
        }
        if (response.DRIVER_STATS && response.DRIVER_STATS.stats) {
          this.driverStats = response.DRIVER_STATS.stats;
        }
        if (response.INVOICE_STATS) {
          this.invoiceStats = response.INVOICE_STATS;
        }
      }
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async getCorpMargin() {
    try {
      const response = await doGet(
        "/api/dashboard/" + this.marginYearMonth + "/margin"
      );
      this.corpMarginMap = response;
      const marginBranchList = Object.keys(this.corpMarginMap);

      for (let index = 0; index < marginBranchList.length; index++) {
        const item = {
          name: marginBranchList[index],
          value: marginBranchList[index],
        };
        if (marginBranchList[index] == "all") {
          item.name = "All";
        }
        this.marginBranchList.push(item);
      }
    } catch (e) {
      common.setError(e.message);
    }
  }
  async getClientBalances() {
    console.log("loggin client balances")
    try {
      const response = await doGet(
        "/api/dashboard/client/balance?yearMonth=" + this.clientbalanceYearMonth
      );
      this.processResponse(response);
      this.clientBalancesMap = response;

      const balanceBranchList = Object.keys(this.clientBalancesMap);
      if (balanceBranchList) {
        for (let index = 0; index < balanceBranchList.length; index++) {
          const item = {
            name: balanceBranchList[index],
            value: balanceBranchList[index],
          };
          if (balanceBranchList[index] == "all") {
            item.name = "All";
          }
          this.balanceBranchList.push(item);
        }
      }
    } catch (e) {
      common.setError(e.message);
    }
  }
  async getClientInvoiceBalances() {
    try {
      const response = await doGet("/api/dashboard/balance/invoice");
      this.clientInvoiceBalances = response;
    } catch (e) {
      common.setError(e.message);
    }
  }
  async getClientPODBalances() {
    try {
      const response = await doGet("/api/dashboard/balance/pod");
      this.clientPODBalances = response;
    } catch (e) {
      common.setError(e.message);
    }
  }
  async getSupplierBalances() {
    try {
      const response = await doGet("/api/dashboard/supplier/balance");
      this.supplierBalancesMap = response;
    } catch (e) {
      common.setError(e.message);
    }
  }
  async getActiveTrips() {
    try {
      const response = await doGet("/api/dashboard/active/trips");
      this.activeTrips = response;
    } catch (e) {
      common.setError(e.message);
    }
  }

  processResponse(response) {
    if (!response) return;
    for (const m in response) {
      const balances = response[m];
      balances.getPodPending1 = this.getPodPending(balances);
      balances.getPodAmount1 = this.getPodAmount(balances);
      balances.getUnInvoiced1 = this.getUnInvoiced(balances);
      balances.getActive1 = this.getActive(balances);
      balances.getAmount1 = this.getAmount(balances);
      balances.getClientAmount1 = this.getClientAmount(balances);
      balances.getExpense1 = this.getExpense(balances);
      balances.getMargin1 = this.getMargin(balances);
      balances.getPOD60Count1 = this.getPOD60Count(balances);
      balances.getPOD60Amount1 = this.getPOD60Amount(balances);
      balances.getPOD30Count1 = this.getPOD30Count(balances);
      balances.getPOD30Amount1 = this.getPOD30Amount(balances);
    }
  }

  getPodPending(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].podPending) temp = temp + balances[_i].podPending;
      }
    }
    return temp;
  }
  getPodAmount(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].podPendingAmount)
          temp = temp + balances[_i].podPendingAmount;
      }
    }
    return temp.toFixed(0);
  }
  getUnInvoiced(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].unInvoicedAmount)
          temp = temp + balances[_i].unInvoicedAmount;
      }
    }
    return temp;
  }
  getActive(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].activeTrips) temp = temp + balances[_i].activeTrips;
      }
    }
    return temp;
  }
  getAmount(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].amount) temp = temp + balances[_i].amount;
      }
    }
    return temp.toFixed(0);
  }
  getClientAmount(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].clientAmount) temp = temp + balances[_i].clientAmount;
      }
    }
    return temp.toFixed(0);
  }
  getExpense(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].expense) temp = temp + balances[_i].expense;
      }
    }
    return temp.toFixed(0);
  }
  getMargin(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].margin) temp = temp + balances[_i].margin;
      }
    }
    return temp.toFixed(0);
  }
  getPOD60Count(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].pod60Count) temp = temp + balances[_i].pod60Count;
      }
    }
    return temp;
  }
  getPOD60Amount(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].pod60amount) temp = temp + balances[_i].pod60amount;
      }
    }
    return temp.toFixed(0);
  }
  getPOD30Count(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].pod30Count) temp = temp + balances[_i].pod30Count;
      }
    }
    return temp;
  }
  getPOD30Amount(balances) {
    let temp = 0;
    if (balances && balances.length > 0) {
      for (let _i = 0; _i < balances.length; _i++) {
        if (balances[_i].pod30amount) temp = temp + balances[_i].pod30amount;
      }
    }
    return temp.toFixed(0);
  }

  @Watch("marginYearMonth")
  onMarginYearMonthChange() {
    this.getCorpMargin();
  }

  @Watch("clientbalanceYearMonth")
  onClientBalanceYearMonthChange() {
    this.getClientBalances();
  }

  async mounted() {
    const d = new Date();
    const year = d.getFullYear();
    // let day = d.getDate();
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    // day = day < 10 ? "0" + day : day;
    this.marginYearMonth = year + "" + month;
    this.clientbalanceYearMonth = year + "" + month;
    this.vehRepMonth = year + "" + month;

    const date = year + "-" + month + "-01";
    let v1 = new Date(date);
    let v2 = new Date(date);
    v1.setMonth(v1.getMonth() - 1);
    v2.setMonth(v2.getMonth() - 2);
    v1 = v1.getMonth()+1;
    v2 = v2.getMonth()+1;
    const year1 = v1 > month ? year - 1 : year;
    const year2 = v2 > month ? year - 1 : year;
    this.prevVehRepMonth = year1 + "" + v1;
    this.prevPrevVehRepMonth = year2 + "" + v2;

    this.getDashboardStats();
    this.getClientBalances();
    this.getCorpMargin();
    this.getClientInvoiceBalances();
    this.getClientPODBalances();
    this.getSupplierBalances();
    this.getActiveTrips();
    this.vehicleRevReports();
  }

  totalClientBalCur = null;
  getTotalClientBal(clientBalances) {
    let amount = null,
      curr = null;
    if (clientBalances && clientBalances.length > 0) {
      for (let i = 0; i < clientBalances.length; i++) {
        amount = amount + clientBalances[i].amount;
        curr = clientBalances[i].currency;
      }
    }
    this.totalClientBalCur = curr;
    if (amount != null) {
      return (curr != "INR" ? curr + "  " : "") + Math.round(amount).toFixed(0);
    } else {
      return "";
    }
  }

  totalInvBalCur = null;
  getTotalClientInvoiceBal() {
    let amount = null,
      curr = null;
    if (this.clientInvoiceBalances && this.clientInvoiceBalances.length > 0) {
      for (let i = 0; i < this.clientInvoiceBalances.length; i++) {
        amount = amount + this.clientInvoiceBalances[i].amount;
        curr = this.clientInvoiceBalances[i].currency;
      }
    }
    this.totalInvBalCur = curr;
    if (amount != null) {
      return (curr != "INR" ? curr + "  " : "") + Math.round(amount).toFixed(0);
    } else {
      return null;
    }
  }

  totalSupBalCur = null;
  getTotalSupBal(supplierBalances) {
    let amount = null,
      curr = null;
    if (supplierBalances && supplierBalances.length > 0) {
      for (let i = 0; i < supplierBalances.length; i++) {
        amount = amount + supplierBalances[i].amount;
        curr = supplierBalances[i].currency;
      }
    }
    this.totalSupBalCur = curr;
    if (amount != null) {
      return (curr != "INR" && curr != null ? curr + "  " : "") + Math.round(amount).toFixed(0);
    } else {
      return "";
    }
  }

  monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  formatIntegerMonth(intMonth) {
    if (intMonth) {
      intMonth = intMonth.toString();
      if (intMonth.indexOf("-") == -1) {
        intMonth =
          this.monthsShort[parseInt(intMonth.substring(4, 6)) - 1] +
          " " +
          intMonth.substring(0, 4);
      }
    }
    return intMonth;
  }
}
</script>

<style scoped>
.bold {
  font-weight: 600;
}
</style>